<script setup lang="ts">
import { cn } from "@/lib/utils";

interface Props {
  stagger?: number;
  delay?: number;
  show?: boolean;
  class?: string;
}

// Set up clean defaults for any instance of your list
const props = withDefaults(defineProps<Props>(), {
  stagger: 0.05,
  delay: 0,
  show: true,
});
</script>

<template>
  <div
    v-if="show"
    :class="cn('content', props.class)"
    :style="{
      '--list-delay': `${delay}s`,
      '--list-stagger': `${stagger}s`,
    }"
  >
    <slot />
  </div>
</template>
